import images from '../assets/img/matched';
import signatures from '../assets/img/initials/signatures';
import photos from '../assets/img/initials/photos';

export const getImage = (imagePath) => {
  const imageArr = imagePath.split('/');
  return imageArr.length && images[imageArr[imageArr.length - 1]];
};

const langSignatures = Object.entries(signatures).reduce(
  (acc, [key, value]) => ({ ...acc, [key.split('.')[0]]: value }),
  {}
);
const langPhotos = Object.entries(photos).reduce(
  (acc, [key, value]) => ({ ...acc, [key.split('.')[0]]: value }),
  {}
);

export const getSignature = (countryCode) => langSignatures[countryCode];
export const getPhoto = (countryCode) => langPhotos[countryCode];
